module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('span', {
    staticClass: "score-label"
  }, [_vm._v("\n    " + _vm._s(_vm.desc) + "\n  ")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5c32790"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScoreLabel.vue
// module id = 1096
// module chunks = 85